import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=10d902dd&scoped=true&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&id=10d902dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d902dd",
  null
  
)

export default component.exports